import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'
import './PGA.css'
import { Radio, Checkbox } from 'react-icheck'
var NotificationSystem = require('react-notification-system');
class PrintPGAAppointmentQueueDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
			loading:false,
			data:{
				insurer_list:[
					{insurer_id:43,name:"บ.วิริยะ"},
					{insurer_id:44,name:"บ.ศรีอยุธยา"},
					{insurer_id:49,name:"บ.สินทรัพย์"},
					{insurer_id:8,name:"บ.กรุงเทพฯ"}
				]
			},
			page_title:'กำลังดึงข้อมูล..',
			dataPage:[{page:0}],
			defaultTypePrint:'3',
			sizeFormat:'landscape'
		}
    this.setSizeFormat('landscape')
    // var cssPagedMedia = (function() {
    //   var style = document.createElement('style');
    //   document.head.appendChild(style);
    //   return function (rule) {
    //     style.innerHTML = rule;
    //   };
    // }());

    // cssPagedMedia.size = function(size) {
    //   cssPagedMedia('@page {size: ' + size + '}');
    // };
    // cssPagedMedia.size('portrait');
  }

	setSizeFormat(format) {
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size(format);
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  loadData() {
  	this.setState({loading:true})
 		PdfStore.loadAppointmentQueueDoc(this.props.wo,(result)=>{
			this.setState({loading:false,data:result.data,page_title:'ไม่พบข้อมูล'})
		},()=>{
			this.setState({loading:false,page_title:'ไม่พบข้อมูล'})
		})
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
	}
	
	onOptionSizeFormatChange(size) {
    let {sizeFormat} = this.state
    sizeFormat = size.value
    this.setState({sizeFormat:sizeFormat},()=>{
			this.setSizeFormat(size.value)
		})
  }

	renderHeader() {
		let {data,sizeFormat} = this.state
		let insurer_id = (data.insurer?data.insurer.insurer_id:'')
		let insurer_list = (data.insurer_list?data.insurer_list:[])
		return(
			<div>
				<div className='text-center'>
					{this.renderLogoUrl(data.logo_url)}
				</div>
				<br />
				<div>
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>
							<tr>
								{insurer_list.map((item,index)=>{
									return(
										<td key={index} style={{width:'100px'}}>
											<Checkbox
												onChange={()=>{}}
												checked={item.insurer_id==insurer_id?true:false}
												checkboxClass="icheckbox_minimal"
												increaseArea="20%"
												label={' '+item.name}
											>
											</Checkbox>
										</td>
									)		
								})}
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		)
	}

  renderBody() {
		let {data,sizeFormat} = this.state
		let order_part = (data.receiving?data.receiving.order_part:'no_order')
    return(
      <div>
      	<div>
					<table className='table table-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>
							<tr>
								<td style={{width:'80px'}}>
									ยี่ห้อ/รุ่น 
								</td>
								<td style={{width:'300px'}}>
									{data.car?data.car.brand:''} {data.car?data.car.model:''}</td>
								<td style={{width:'80px'}}>
									ทะเบียน 
								</td>
								<td style={{width:'150px'}}>
									{data.car?data.car.car_registration_no:''}
								</td>
							</tr>
						</tbody>
					</table>
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>
							<tr>
								<td style={{width:'80px'}}>
									
								</td>
								<td className='title' style={{width:'300px'}}>
									ค่า EX <span style={{width:'200px',borderBottom:'1px solid #111',display:'inline-block'}}>{data.car?data.car.excess:''}</span>
								</td>
								<td style={{width:'80px'}}>
									
								</td>
								<td style={{width:'150px'}}>
									
								</td>
							</tr>
						</tbody>
					</table>
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>
							<tr>
								<td className='title' style={{width:'500px'}}>
									<Radio
        						onChange={()=>{}}
					          checked={order_part==='order'?true:false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' มีรายการสั่งอะไหล่'}
					        >
					        </Radio>
								</td>
								<td style={{width:'400px',position:'relative'}}>
									<Radio
        						onChange={()=>{}}
					          checked={false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' คิวเข้าซ่อมวันที่...................................................'}
					        >
									</Radio>
									<span className='advance-date' style={{position:'absolute',right:'70px',top:'0'}}>{data.receiving?data.receiving.advance_date:''}</span>
								</td>
							</tr>
							<tr>
								<td className='text-center' colSpan={2} style={{position:'relative'}}>
									ระยะเวลาการซ่อม....................................วันทำการ
									<span className='fixing-day' style={{position:'absolute',right:(sizeFormat==='portrait'?'300px':'250px'),top:'0'}}>{data.receiving?data.receiving.fixing_day:''}</span>
								</td>
							</tr>
						</tbody>
					</table>
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>
							<tr>
								<td colSpan={2} className='title' style={{position:'relative'}}>
									<u>เอกสารที่ต้องนำมายื่นเพิ่มเติม</u>
									<div style={{display:(data.qrcode_url?'':'none'),position:'absolute',top:(sizeFormat==='portrait'?'-15px':'-5px'),right:'100px'}}>
										<img alt='' src={data.qrcode_url} width={sizeFormat==='portrait'?'150':'100'} height={sizeFormat==='portrait'?'150':'100'} />
									</div>
								</td>
							</tr>
							<tr>
								<td style={{width:'100px',maxWidth:'100px'}}>
									<Radio
        						onChange={()=>{}}
					          checked={false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' กรมธรรม์'}
					        >
					        </Radio>
								</td>		
								<td>		
									<Radio
        						onChange={()=>{}}
					          checked={false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' สำเนาทะเบียนรถ'}
					        >
					        </Radio>
								</td>
							</tr>	
							<tr>	
								<td>
									<Radio
        						onChange={()=>{}}
					          checked={false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' ใบขับขี่'}
					        >
					        </Radio>
								</td>		
								<td>
									<Radio
        						onChange={()=>{}}
					          checked={false}
					          radioClass="iradio_minimal"
					          increaseArea="20%"
					          label={' ....................................'}
					        >
					        </Radio>
								</td>
							</tr>
						</tbody>
					</table>
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tbody>		
							<tr>
								<td className='title'>หมายเหตุ <span className='remark' style={{width:(sizeFormat==='portrait'?'628px':'470px'),borderBottom:'1px solid #111',display:'inline-block'}}></span></td>
							</tr>
							<tr>
								<td className='title'><span style={{width:(sizeFormat==='portrait'?'700px':'525px'),borderBottom:'1px solid #111',display:'inline-block'}}></span></td>
							</tr>
						</tbody>
					</table>	
					<table className='table table-no-bd' style={{marginBottom:(sizeFormat==='portrait'?'20px':'10px')}}>
						<tr>
							<td style={{width:'200px'}} className='text-center'></td>
							<td style={{width:'200px'}} className='text-center'>ผู้รับเรื่อง</td>
							<td style={{width:'200px'}} className='text-center'></td>
						</tr>
						<tr>
							<td colSpan={3} className='text-center'><br /></td>
						</tr>
						<tr>
							<td></td>
							<td><span style={{width:'100%',borderBottom:'1px solid #111',display:'inline-block'}}></span></td>
							<td>วันที่</td>
						</tr>
					</table>		
				</div>
      </div>
    )
  }

	renderFooter() {
		return(
			<div className='detail-footer'>
				ลูกค้าสามารถโทรเข้ามาสอบถามเพิ่มเติม หรือแจ้งเปลี่ยนแปลงวันเข้าซ่อม <br />
				ได้ที่เบอร์ 038-381727 ถึง 29, 087-940-9922, 087-941-9900 <br />
				Line id: @phetgarage <br />
				E-Mail: phetgarage8@hotmail.co.th <br />
				FB: เพรชการาจ ศูนย์ซ่อมสี & โบรคเกอร์ <br />
				<div className='detail-box-text'>
					<i>"ขับรถด้วยความมั่นใจ เมื่อทำประกันกับ... เพรชการาจ "</i>
				</div>
			</div>
		)
	}

  renderComponentPage(page,index) {
		let {defaultTypePrint,sizeFormat} = this.state
		if (sizeFormat==='portrait') {
			return(
				<div className='font-print print-pga' key={index}>
					<div style={{display:defaultTypePrint==='2'||page===1?'none':''}}>
						<div style={{position:'relative'}}>
							{this.renderHeader()}
							<span className='sec-copy-doc text-right text-type-print' style={{top:'0',right:'0',position:'absolute'}}>
								<span style={{display:defaultTypePrint==='0'?'none':''}}>ต้นฉบับ</span>
							</span>	
							{this.renderBody()}
							{this.renderFooter()}
						</div>
					</div>    
					<div style={{display:defaultTypePrint==='1'||page===0?'none':''}}>
						<div style={{position:'relative'}}>
							{this.renderHeader()}
							<span className='sec-copy-doc text-right text-type-print' style={{top:'0',right:'0',position:'absolute'}}>
								<span style={{display:defaultTypePrint==='0'?'none':''}}>สำเนา</span>
							</span>	
							{this.renderBody()}
							{this.renderFooter()}
						</div>
					</div>    
				</div>  
			)
		} else {
			return(
				<div className='font-print print-pga' key={index}>
					<div style={{width:'100%',position:'relative'}}>
						<div style={{width:'49%',display:'inline-block',margin:'0 5px 0 0'}}>
							<div>
								<div style={{position:'relative'}}>
									{this.renderHeader()}
									<span className='sec-copy-doc text-right text-type-print' style={{top:'0',right:'0',position:'absolute'}}>
										<span style={{display:defaultTypePrint==='0'?'none':''}}>{defaultTypePrint==='2'?'สำเนา':'ต้นฉบับ'}</span>
									</span>	
									{this.renderBody()}
									{this.renderFooter()}
								</div>
							</div>
						</div>
						<div style={{width:'49%',display:'inline-block',margin:'0 0 0 5px'}}>
							<div style={{display:defaultTypePrint==='3'?'':'none'}}>
								<div style={{position:'relative'}}>
									{this.renderHeader()}
									<span className='sec-copy-doc text-right text-type-print' style={{top:'0',right:'0',position:'absolute'}}>
										<span style={{display:defaultTypePrint==='0'?'none':''}}>สำเนา</span>
									</span>	
									{this.renderBody()}
									{this.renderFooter()}
								</div>
							</div>
						</div>
					</div>
				</div>
			)		
		}		
  }

  onTypePrintChange(e) {
		let {dataPage,sizeFormat} = this.state
		if (sizeFormat==='portrait') {
			if (e==='0'||e==='1')
				dataPage = [{page:0}]
			else if (e==='2')
				dataPage = [{page:1}]
			else if (e==='3')
				dataPage = [{page:0},{page:1}]
		} else {
			dataPage = [{page:0}]
		}			
		this.setState({defaultTypePrint:e,dataPage:dataPage})
  }

  render() {
		let {loading,dataPage} = this.state
		return(
      <div>
        <PrintPreview
            loading={loading}
            leftBarTitle={this.props.title}
            onTypePrintChange={this.onTypePrintChange.bind(this)}
        		defaultTypePrint={this.state.defaultTypePrint}
        		showPageNumber={false}
						onOptionSizeFormatChange={this.onOptionSizeFormatChange.bind(this)}
						size={this.state.sizeFormat}
						isDelayPrint={true}
          >
            {
              dataPage.map((item,index)=> {
            		return this.renderComponentPage(item.page,index)
              })	
            }
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintPGAAppointmentQueueDoc.defaultProps = {
  title:'',  
  mode:''
}
export default PrintPGAAppointmentQueueDoc;


// WEBPACK FOOTER //
// ./src/view/print/pga/PrintPGAAppointmentQueueDoc.js